import { Link, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import type { PageProps } from "@/types/inertia"
import "@/styles/public-order.css"

// The account card on the two thank-you pages (M3, M6 decision 15). Signed
// in: the enquiry is already on the account, so it links to it. A guest is
// invited, never pushed: signing up from here claims this browser's enquiry
// and designs at once (HistoryClaim) and lands on /account.
export function AccountPromptCard({
  noun,
  trackHref,
  titleId = "account-prompt-title",
}: {
  noun: "order" | "enquiry"
  /** Where "Track it from your account" goes when signed in. */
  trackHref: string
  titleId?: string
}) {
  const { props } = usePage<PageProps>()
  const currentUser = props.current_user

  return (
    <aside className="ord-account self-start" aria-labelledby={titleId}>
      {currentUser ? (
        <>
          <div className="eyebrow">Your account</div>
          <h2 id={titleId}>Track it from your account</h2>
          <p className="mt-4">
            This {noun} is linked to your account, {currentUser.email}.
          </p>
          <Button asChild variant="gold" size="lg" className="mt-8">
            <Link href={trackHref}>Track it from your account</Link>
          </Button>
        </>
      ) : (
        <>
          <div className="eyebrow">Optional</div>
          <h2 id={titleId}>Follow your {noun}</h2>
          <p className="mt-4">
            There is no need for an account — we will be in touch either way. If you would like to
            follow this {noun} online, you can create one.
          </p>
          <Button asChild variant="ghost-hairline" size="lg" className="mt-8">
            <Link href="/signup">Create an account to follow this {noun}</Link>
          </Button>
        </>
      )}
    </aside>
  )
}
